package com.essntl.features.organization.ui.organizationdetails

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import com.essntl.core.utils.viewmodel.PaginationState
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.contact.domain.model.ContactModel
import com.essntl.features.file.ui.FileState
import com.essntl.features.organization.domain.model.OrganizationModel

data class OrganizationDetailsState(
    val getOrganization: State<OrganizationModel> = State(),
    val organization: MutableState<OrganizationModel> = mutableStateOf(OrganizationModel.empty),
    val getAllOrganizations: PaginationState<OrganizationModel> = PaginationState(),
    val editOrganization: State<OrganizationModel> = State(),
    val getAllContacts: State<List<ContactModel>> = State(),
    val selectedContactId: String = "",
    val selectedParentOrganization: OrganizationModel? = null,
    val addAddress: Boolean = false,
    val fileState: FileState = FileState(),
    val uploadLogo: State<Unit> = State(),
)